interface ChartSegmentedControlProps<T extends string> {
  options: ReadonlyArray<{ value: T; label: string }>;
  value: T;
  onChange: (value: T) => void;
}

/**
 * Shared segmented control for the dashboard charts — the 30d/90d/1y range
 * toggle and the Category/Discipline/Stage grouping picker render through
 * this one component so their look stays identical: a pill group whose
 * active segment gets a light grey fill and medium weight.
 */
export function ChartSegmentedControl<T extends string>({
  options,
  value,
  onChange,
}: ChartSegmentedControlProps<T>) {
  return (
    <div className="flex rounded-md border">
      {options.map((opt, i) => (
        <button
          key={opt.value}
          className={`px-2.5 py-1 text-xs font-medium transition-colors ${
            value === opt.value
              ? "bg-neutral-100 text-neutral-900"
              : "text-muted-foreground hover:text-neutral-700"
          } ${i === 0 ? "rounded-l-md" : ""} ${i === options.length - 1 ? "rounded-r-md" : ""}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
